var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ChallengeService, TeamMembershipStatus } from 'app/shared/services/challenge.service';
import { UserService } from 'app/shared/services/user.service';
import * as moment from 'moment';
import { Subject } from 'rxjs';
import { combineLatest } from 'rxjs/observable/combineLatest';
var TeamSelectMode;
(function (TeamSelectMode) {
    TeamSelectMode["TEAMS_OVERVIEW"] = "teamsOverview";
    TeamSelectMode["CONFIRM_JOIN"] = "confirmJoin";
    TeamSelectMode["TEAM_DETAILS"] = "teamDetails";
})(TeamSelectMode || (TeamSelectMode = {}));
/**
 * Modal component to select team out of available teams or found an own team and invite members.
 */
var TeamSelectComponent = (function () {
    function TeamSelectComponent(router, userService, challengeService, snackBar, translate, route) {
        this.router = router;
        this.userService = userService;
        this.challengeService = challengeService;
        this.snackBar = snackBar;
        this.translate = translate;
        this.route = route;
        // Currently active navigation step
        this.mode = TeamSelectMode.TEAMS_OVERVIEW;
        this.showTeamCreationDialog = false;
        // Ids of users which should be invited when team is created
        this.invitedUsers = [];
        this.ngUnsubscribe = new Subject();
        this.createTeamForm = new FormGroup({
            name: new FormControl('', [Validators.required, Validators.minLength(4), Validators.maxLength(25)]),
        });
        this.inviteUserForm = new FormGroup({
            email: new FormControl('', [
                Validators.required,
                Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/),
            ]),
        });
        // Reference to TeamSelectMode to be able to use it in template
        this.TeamSelectMode = TeamSelectMode;
    }
    TeamSelectComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.userService.currentUser.takeUntil(this.ngUnsubscribe).subscribe(function (user) {
            if (!user) {
                return;
            }
            _this.currentUser = user;
        });
        combineLatest(this.route.params, this.route.queryParams, this.challengeService.displayedChallenge).takeUntil(this.ngUnsubscribe).subscribe(function (_a) {
            var rParams = _a[0], qParams = _a[1], challenge = _a[2];
            if (rParams.challengeID) {
                _this.requestedChallengeId = rParams.challengeID;
            }
            if (qParams.invitedTeamID) {
                _this.invitedTeamId = qParams.invitedTeamID;
            }
            var error;
            if ((!challenge && _this.challengeService.noChallengeFound) ||
                (_this.requestedChallengeId && challenge && challenge._id !== _this.requestedChallengeId)) {
                console.log(challenge);
                console.log(_this.challengeService.noChallengeFound);
                console.log(_this.requestedChallengeId);
                _this.navigateDashboard();
                return;
            }
            else if (challenge && moment().isAfter(moment(challenge.start)) && _this.invitedTeamId) {
                error = 'CHALLENGE.error.invitationInvalidChallengeAlreadyRunning';
            }
            else if (challenge && moment().isAfter(moment(challenge.start))) {
                error = 'CHALLENGE.error.preparationPhaseOver';
            }
            if (error) {
                _this.translate.get(error).subscribe(function (text) {
                    _this.snackBar.open(text, null, {
                        verticalPosition: 'top',
                        duration: 6000,
                        panelClass: ['b2a-error', 'top'],
                    });
                });
                _this.navigateDashboard();
            }
            _this.challenge = challenge;
        });
        this.challengeService.teamUser
            .withLatestFrom(this.challengeService.teams, this.challengeService.team)
            .takeUntil(this.ngUnsubscribe)
            .subscribe(function (_a) {
            var teamUser = _a[0], teams = _a[1], team = _a[2];
            if (teams) {
                if (_this.invitedTeamId && !teams.find(function (invitedTeam) { return invitedTeam._id === _this.invitedTeamId; })) {
                    _this.translate.get('CHALLENGE.error.invitationInvalidTeamNotExisting').subscribe(function (text) {
                        _this.snackBar.open(text, null, {
                            verticalPosition: 'top',
                            duration: 8000,
                            panelClass: ['b2a-error', 'top'],
                        });
                    });
                }
                // Set status whether currently logged in user has an invitation to the team
                for (var _i = 0, teams_1 = teams; _i < teams_1.length; _i++) {
                    var team_1 = teams_1[_i];
                    var hasInvitation = team_1.userGroups.invitations.find(function (user) { return user._id === _this.currentUser._id; });
                    team_1.hasInvitation = !!hasInvitation;
                }
                // Sort teams so that teams where user has invitations to are displayed at top
                var sortedTeams = teams.sort(function (team1, team2) {
                    if (team1.hasInvitation && !team2.hasInvitation) {
                        return -1;
                    }
                    else if (!team2.hasInvitation && team1.hasInvitation) {
                        return 1;
                    }
                    else {
                        var team1AtMemberLimit = team1.userGroups.members.length + team1.userGroups.invitations.length >= _this.challenge.maximumTeamMembers;
                        var team2AtMemberLimit = team2.userGroups.members.length + team2.userGroups.invitations.length >= _this.challenge.maximumTeamMembers;
                        if (team1AtMemberLimit && !team2AtMemberLimit) {
                            return 1;
                        }
                        else if (team2AtMemberLimit && !team1AtMemberLimit) {
                            return -1;
                        }
                        else {
                            return 0;
                        }
                    }
                });
                _this.teams = teams;
            }
            if (team && teamUser.membershipStatus !== TeamMembershipStatus.INVITATION) {
                if (teamUser.isFounder && _this.showTeamCreationDialog) {
                    _this.setTeamDetails(team._id);
                    _this.mode = TeamSelectMode.TEAM_DETAILS;
                }
                else {
                    setTimeout(function () {
                        _this.navigateTeamDetails();
                    });
                }
            }
            else {
                _this.mode = TeamSelectMode.TEAMS_OVERVIEW;
            }
        });
    };
    /**
     * Sets the currently selected team (required for team creation dialog and confirm join dialog)
     */
    TeamSelectComponent.prototype.setTeamDetails = function (teamID) {
        var foundTeam = this.teams.find(function (team) { return team._id === teamID; });
        if (teamID && foundTeam) {
            this.teamDetails = foundTeam;
            this.founder = this.teamDetails.users.find(function (user) { return !!user.isFounder; });
        }
        else {
            this.teamDetails = undefined;
            this.founder = undefined;
        }
    };
    /**
     * Shows the confirm join dialog where the user has to confirm that she wants to join the team
     */
    TeamSelectComponent.prototype.showConfirmJoinDialog = function (teamID) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.setTeamDetails(teamID);
                this.mode = TeamSelectMode.CONFIRM_JOIN;
                return [2 /*return*/];
            });
        });
    };
    /**
     * Cancels the confirm join team dialog
     */
    TeamSelectComponent.prototype.cancelDialog = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.setTeamDetails(undefined);
                this.mode = TeamSelectMode.TEAMS_OVERVIEW;
                return [2 /*return*/];
            });
        });
    };
    /**
     * Cancels the team creation dialog
     */
    TeamSelectComponent.prototype.cancelTeamCreation = function () {
        var _this = this;
        if (this.challenge._id && this.teamDetails) {
            this.challengeService.deleteTeam(this.challenge._id, this.teamDetails._id).then(function () {
                _this.invitedUsers = [];
                _this.setTeamDetails(undefined);
                _this.showTeamCreationDialog = false;
                _this.mode = TeamSelectMode.TEAMS_OVERVIEW;
            });
        }
    };
    /**
     * Adds the user to the currently selected team
     */
    TeamSelectComponent.prototype.applyForTeam = function () {
        var _this = this;
        this.challengeService.applyForTeam(this.challenge._id, this.teamDetails._id).catch(function () {
            _this.translate.get('CHALLENGE.error.general').subscribe(function (text) {
                _this.snackBar.open(text, null, {
                    verticalPosition: 'top',
                    duration: 4000,
                    panelClass: ['b2a-error', 'top'],
                });
                _this.challengeService.reloadTeams();
            });
        });
    };
    /**
     * Opens the team creation dialog
     */
    TeamSelectComponent.prototype.createTeam = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                if (this.challenge) {
                    this.showTeamCreationDialog = true;
                    this.challengeService
                        .createTeam(this.challenge._id, this.createTeamForm.value)
                        .then(function (createdTeam) {
                        _this.setTeamDetails(createdTeam._id);
                        _this.mode = TeamSelectMode.TEAM_DETAILS;
                    })
                        .catch(function (error) {
                        var errorObject = error.body.error;
                        if (errorObject.startsWith('maximum_challenge_members')) {
                            _this.translate.get('CHALLENGE.error.maximumChallengeMemberReached').subscribe(function (text) {
                                _this.snackBar.open(text, null, {
                                    verticalPosition: 'top',
                                    duration: 4000,
                                    panelClass: ['b2a-error', 'top'],
                                });
                            });
                        }
                        else if (errorObject.startsWith('name_conflict')) {
                            _this.translate.get('CHALLENGE.error.conflictingTeamName').subscribe(function (text) {
                                _this.snackBar.open(text, null, {
                                    verticalPosition: 'top',
                                    duration: 4000,
                                    panelClass: ['b2a-error', 'top'],
                                });
                            });
                        }
                    });
                }
                return [2 /*return*/];
            });
        });
    };
    /**
     * Called when finishing the team create assistant and all invitations are sent out
     */
    TeamSelectComponent.prototype.finishTeamCreation = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.challengeService
                    .inviteUsers(this.challenge._id, this.teamDetails._id, this.invitedUsers.map(function (user) { return user.email; }))
                    .then()
                    .catch(function () {
                    _this.translate.get('CHALLENGE.error.general').subscribe(function (text) {
                        _this.snackBar.open(text, null, {
                            verticalPosition: 'top',
                            duration: 4000,
                            panelClass: ['b2a-error', 'top'],
                        });
                    });
                    _this.challengeService.reloadTeams();
                });
                this.navigateTeamDetails();
                return [2 /*return*/];
            });
        });
    };
    /**
     * Invites a user to the team
     */
    TeamSelectComponent.prototype.inviteUserToTeam = function () {
        var _this = this;
        this.challengeService
            .checkUserEligibility(this.challenge._id, this.teamDetails._id, this.inviteUserForm.value.email)
            .then(function (result) {
            var userAlreadyInvited = _this.invitedUsers.find(function (user) {
                return user.email === result.email;
            });
            if (!userAlreadyInvited) {
                _this.invitedUsers.push(result);
            }
            _this.inviteUserForm.reset();
        })
            .catch(function (error) {
            var errorObject = error.body.error.error;
            if (errorObject.startsWith('invalid_domain')) {
                _this.translate.get('CHALLENGE.error.invalidInvitationDomain').subscribe(function (text) {
                    _this.snackBar.open(text, null, {
                        verticalPosition: 'top',
                        duration: 4000,
                        panelClass: ['b2a-error', 'top'],
                    });
                });
            }
            else if (errorObject.startsWith('maximum_challenge_members')) {
                _this.translate.get('CHALLENGE.error.maximumChallengeMemberReached').subscribe(function (text) {
                    _this.snackBar.open(text, null, {
                        verticalPosition: 'top',
                        duration: 4000,
                        panelClass: ['b2a-error', 'top'],
                    });
                });
            }
            else {
                _this.translate.get('CHALLENGE.error.userInviteFailed').subscribe(function (text) {
                    _this.snackBar.open(text, null, {
                        verticalPosition: 'top',
                        duration: 4000,
                        panelClass: ['b2a-error', 'top'],
                    });
                });
            }
        });
    };
    /**
     * Accepts an invitation to the team
     */
    TeamSelectComponent.prototype.acceptInvitation = function (teamID) {
        var _this = this;
        this.challengeService
            .acceptInvitation(this.challenge._id, teamID, this.currentUser._id)
            .then()
            .catch(function (error) {
            var errorObject = error.body.error.error;
            if (errorObject.startsWith('maximum_challenge_members')) {
                _this.translate.get('CHALLENGE.error.maximumChallengeMemberReached').subscribe(function (text) {
                    _this.snackBar.open(text, null, {
                        verticalPosition: 'top',
                        duration: 4000,
                        panelClass: ['b2a-error', 'top'],
                    });
                });
            }
            else {
                _this.translate.get('CHALLENGE.error.general').subscribe(function (text) {
                    _this.snackBar.open(text, null, {
                        verticalPosition: 'top',
                        duration: 4000,
                        panelClass: ['b2a-error', 'top'],
                    });
                });
                location.reload();
            }
        });
    };
    /**
     * Deny invitation to a team
     */
    TeamSelectComponent.prototype.denyInvitation = function (teamID) {
        var _this = this;
        this.challengeService
            .declineInvitation(this.challenge._id, teamID, this.currentUser.email)
            .then()
            .catch(function () {
            _this.translate.get('CHALLENGE.error.general').subscribe(function (text) {
                _this.snackBar.open(text, null, {
                    verticalPosition: 'top',
                    duration: 4000,
                    panelClass: ['b2a-error', 'top'],
                });
                location.reload();
            });
        });
    };
    /**
     * Called by team founder to cancel an invitation of the user to the team
     */
    TeamSelectComponent.prototype.cancelInvitation = function (email) {
        var userIndex = this.invitedUsers.findIndex(function (user) { return user.email === email; });
        if (userIndex !== -1) {
            this.invitedUsers.splice(userIndex, 1);
        }
    };
    TeamSelectComponent.prototype.navigateTeamDetails = function () {
        this.router.navigate(['stats']).then();
    };
    TeamSelectComponent.prototype.navigateDashboard = function () {
        this.router.navigate(['/dashboard']).then();
    };
    /**
     * On destroy cancel active subscriptions
     */
    TeamSelectComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    return TeamSelectComponent;
}());
export { TeamSelectComponent };



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/pages/team-select/team-select.component.ts.pre-build-optimizer.js